import { createSelector } from 'reselect';

import { getSiteUrl, getCompId } from 'shared/selectors/app-settings';
import parseQueryParams from 'shared/utils/get-query-params';


const getQueryParams = createSelector([getSiteUrl], parseQueryParams);

const getVideoIdFromUrl = createSelector(
  [getQueryParams, getCompId],
  (queryParams, compId) => {

    if (!compId || compId !== queryParams['wix-vod-comp-id']) {
      return null;
    }

    return queryParams['wix-vod-video-id'];
});

export default getVideoIdFromUrl;




// WEBPACK FOOTER //
// ./src/widget/selectors/video-id-from-url.js